import {
  NEW_TRANSCRIPT_EXPERIENCE_VIEWER,
  REQUEST_PUSH_PERMISSIONS,
  SHOW_FIRST_CAPTION_EXPERIENCE,
  SHOW_REVIEW_TRANSCRIPT_BUTTON_HIGHLIGHT,
} from 'constants/triggers';

let localStorage;

// block third party cookies check
// https://useloom.atlassian.net/browse/LOOM-1639
try {
  localStorage = window && window.localStorage;
} catch (err) {
  // do nothing
}

export const setLocalStorageKey = (key, val) => {
  localStorage && localStorage.setItem(key, JSON.stringify(val));
};

export const getLocalStorageKey = key =>
  localStorage && JSON.parse(localStorage.getItem(key));

export const clearLocalStorageKey = key =>
  localStorage && localStorage.removeItem(key);

const requestPushPermissionKey = `triggers:${REQUEST_PUSH_PERMISSIONS}`;

export const setRequestPushPermissionData = data =>
  setLocalStorageKey(requestPushPermissionKey, data);
export const getRequestPushPermissionData = () =>
  getLocalStorageKey(requestPushPermissionKey);
export const clearRequestPushPermissionData = () =>
  clearLocalStorageKey(requestPushPermissionKey);

const newTranscriptExperiencePermissionKey = `triggers:${NEW_TRANSCRIPT_EXPERIENCE_VIEWER}`;

export const setNewTranscriptExperienceData = data =>
  setLocalStorageKey(newTranscriptExperiencePermissionKey, data);
export const getNewTranscriptExperienceData = () =>
  getLocalStorageKey(newTranscriptExperiencePermissionKey);

const newCcExperiencePermissionKey = `triggers:${SHOW_FIRST_CAPTION_EXPERIENCE}`;

export const setNewCcExperienceData = data =>
  setLocalStorageKey(newCcExperiencePermissionKey, data);
export const getNewCcExperienceData = () =>
  getLocalStorageKey(newCcExperiencePermissionKey);

const showCaptionsKey = 'showCaptions';

export const getShowCaptions = () => getLocalStorageKey(showCaptionsKey);

export const setShowCaptions = showCaptions =>
  setLocalStorageKey(showCaptionsKey, showCaptions);

const showReviewTranscriptButtonHightlightKey = `triggers:${SHOW_REVIEW_TRANSCRIPT_BUTTON_HIGHLIGHT}`;

export const getShowReviewTranscriptButtonHightlight = () =>
  getLocalStorageKey(showReviewTranscriptButtonHightlightKey);

export const setShowReviewTranscriptButtonHightlight = data =>
  setLocalStorageKey(showReviewTranscriptButtonHightlightKey, data);
